import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const GpsTrackersTableSkeleton = () => {
  return Array(10)
    .fill('')
    .map((_, i) => (
      <tr key={i} className={style.usersBodyRow}>
        <td className={style.trackersTableTd}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td className={style.trackersTableTd}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td className={style.trackersTableTd}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td className={style.trackersTableTd}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td className={style.trackersTableTd}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      </tr>
    ));
};

export default GpsTrackersTableSkeleton;
